// import { transparentize } from 'polished';
import styled, { extensionsHook, withProps } from '../styled-components';
import { deprecatedCss } from './mixins';
export const PropertiesTableCaption = styled.caption.withConfig({
  componentId: "dz44d2-0"
})(["text-align:right;font-size:0.9em;font-weight:normal;color:", ";"], props => props.theme.colors.text.secondary);
export const PropertyCell = styled.td.withConfig({
  componentId: "dz44d2-1"
})(["border-left:1px solid ", ";box-sizing:border-box;position:relative;padding:10px 10px 10px 0;tr:first-of-type > &,tr.last > &{border-left-width:0;background-position:top left;background-repeat:no-repeat;background-size:1px 100%;}tr:first-of-type > &{background-image:linear-gradient( to bottom,transparent 0%,transparent 22px,", " 22px,", " 100% );}tr.last > &{background-image:linear-gradient( to bottom,", " 0%,", " 22px,transparent 22px,transparent 100% );}tr.last + tr > &{border-left-color:transparent;}tr.last:first-child > &{background:none;border-left-color:transparent;}"], props => props.theme.schema.linesColor, props => props.theme.schema.linesColor, props => props.theme.schema.linesColor, props => props.theme.schema.linesColor, props => props.theme.schema.linesColor);
export const PropertyCellWithInner = styled(PropertyCell).withConfig({
  componentId: "dz44d2-2"
})(["padding:0;"]);
export const PropertyNameCell = withProps<{
  kind?: string;
}>(styled(PropertyCell))`
  vertical-align: top;
  line-height: 20px;
  white-space: nowrap;
  font-size: 0.929em;
  font-family: ${props => props.theme.typography.headings.fontFamily};

  &.deprecated {
    ${deprecatedCss};
  }

  ${({
  kind
}) => kind !== 'field' ? 'font-style: italic' : ''};

  ${extensionsHook('PropertyNameCell')};
`;
export const PropertyDetailsCell = styled.td.withConfig({
  componentId: "dz44d2-3"
})(["border-bottom:1px solid #9fb4be;padding:10px 0;width:", ";box-sizing:border-box;tr.expanded &{border-bottom:none;}"], props => props.theme.schema.defaultDetailsWidth);
export const PropertyBullet = styled.span.withConfig({
  componentId: "dz44d2-4"
})(["color:", ";font-family:", ";margin-right:10px;&::before{content:'';display:inline-block;vertical-align:middle;width:10px;height:1px;background:", ";}&::after{content:'';display:inline-block;vertical-align:middle;width:1px;background:", ";height:7px;}"], props => props.theme.schema.linesColor, props => props.theme.typography.code.fontFamily, props => props.theme.schema.linesColor, props => props.theme.schema.linesColor);
export const InnerPropertiesWrap = styled.div.withConfig({
  componentId: "dz44d2-5"
})(["padding:", ";"], ({
  theme
}) => theme.schema.nestingSpacing);
export const PropertiesTable = styled.table.withConfig({
  componentId: "dz44d2-6"
})(["border-collapse:separate;border-radius:3px;font-size:", ";border-spacing:0;width:100%;> tr{vertical-align:middle;}& ", ",& ", " ", " ", ",& ", " ", " ", " ", " ", "{margin:", ";margin-right:0;background:", ";}& ", " ", ",& ", " ", " ", " ", ",& ", " ", " ", " ", " ", " ", "{background:#ffffff;}"], props => props.theme.typography.fontSize, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, ({
  theme
}) => theme.schema.nestingSpacing, ({
  theme
}) => theme.schema.nestedBackground, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap, InnerPropertiesWrap);